import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultSeatToPassengerAction } from "../../../../Orchestrator/Types/Interface/EventParams/SeatingAction";
import { IPassenger } from "../../../../Orchestrator/Types/Index";

export class DefaultSeatAllocationAction extends BaseAction<void, IDefaultSeatToPassengerAction> {

    override async run(): Promise<void | null> {
        try {
            const { passengers, placeMapResponse, bookingResponse, allPassengers } = this.params!;
            
            const { bookedOffers } = bookingResponse.booking;
            const preSelections = placeMapResponse?.vehicleAvailability?.preSelections ?? [];

            // We no longer update passenger objects with seat assignments since seats are now managed 
            // per segment through the selectedSeats atom. This prevents seat assignments from one 
            // segment appearing in other segments.
            
            // However, we still need to ensure passenger state is properly maintained for other purposes
            // Use the passed allPassengers if available, otherwise use the provided passengers
            const currentPassengers = allPassengers || passengers;
            
            // Only update passenger state if we have allPassengers (indicating we need to maintain full state)
            if (allPassengers) {
                // Create a map of display passengers by ID for quick lookup
                const displayPassengersMap = new Map(passengers.map(p => [p.id, p]));
                
                // Merge: keep existing passengers that aren't in the display list, and update those that are
                // But don't override seat assignments since those are now handled per segment
                const mergedPassengers = currentPassengers.map((existingPassenger: IPassenger) => {
                    const displayPassenger = displayPassengersMap.get(existingPassenger.id);
                    if (displayPassenger) {
                        // Merge passenger data but preserve any existing seat assignments
                        return {
                            ...existingPassenger,
                            ...displayPassenger,
                            // Preserve existing seat assignments to avoid cross-segment contamination
                            placeNumber: existingPassenger.placeNumber || displayPassenger.placeNumber || "",
                            coachNumber: existingPassenger.coachNumber || displayPassenger.coachNumber || ""
                        };
                    }
                    return existingPassenger;
                });

                updateRecoilState("passengerStateAtom", mergedPassengers);
            }
        } catch (error) {
            console.error("Error in DefaultSeatAllocationAction:", error);
        }
    }
}

// Create a singleton instance
export const defaultSeatAllocationAction = new DefaultSeatAllocationAction(); 